import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

import useConfig from 'UI/customHooks/useConfig';

import './styles.css';
import { logoutUser } from '../../../../auth/userCredentials';

const forbiddenStatuses = [400, 403, 422];

const AuthErrorPage = ({ status }) => {
  const { cdnUrl } = useConfig();

  // ensure user is logged out
  useEffect(() => {
    logoutUser(false);
  }, []);

  let errorTitle = "We've had a technical problem";

  let content = (
    <p className="auth_error_info">
      We are working on fixing it. Please <a href="/">try again</a> later!
    </p>
  );

  if (forbiddenStatuses.includes(status)) {
    errorTitle = 'You cannot do that!';
    content = (
      <p className="auth_error_info">
        There was something in your request which was not allowed. Please{' '}
        <a href="/">go back and try again</a>.
      </p>
    );
  }

  const themeName = window.PALYX_WHITE_LABEL?.name;
  const title = themeName ? `${themeName} - ${errorTitle}` : errorTitle;

  return [
    <Helmet key="helmet" defer={false} title={title} />,
    <div key="body" className="auth_error_body">
      <div className="auth_error_wrapper">
        <div className="auth_error_content">
          <div className="auth_error_textWrapper">
            <p className="auth_error_subtitle">{errorTitle}</p>
            {content}
            <p>Application version: v.{import.meta.env.VITE_VERSION}</p>
          </div>
          <img
            className="auth_error_image"
            src={`${cdnUrl}/assets/errorPage/Error.svg`}
            alt={title}
          />
        </div>
      </div>
    </div>,
  ];
};

export default AuthErrorPage;
